import React, { useState, useRef, useEffect } from 'react'
import {
    Button, Typography, Alert, QRCode, Flex, Table, Badge, Tabs, Drawer, Form,
    Checkbox, Input, Upload, Select, Card, Divider, InputNumber, Tag, Tooltip, Skeleton,
    Breadcrumb,
    Image
} from 'antd'
import api, { BASEURL } from '../../../service/axios'
import { useToasts } from 'react-toast-notifications';
import ReactToPrint from 'react-to-print';
import TelefoneBrasileiroInput from "react-telefone-brasileiro";
import {
    CheckOutlined,
    CloseOutlined,
    DeleteOutlined,
    UploadOutlined,
    FileTextOutlined,
    FormOutlined,
    LoadingOutlined,
    NotificationTwoTone,
    SendOutlined,
    SearchOutlined,
    FilePdfOutlined,
    PrinterOutlined,
    DownOutlined,
    DownloadOutlined
} from '@ant-design/icons';
import { userState } from '../../../service/database'
import { useRecoilState } from 'recoil'
import dayjs from 'dayjs';
import InputMask from 'react-input-mask';
import { cnpj, cpf, validator } from 'cpf-cnpj-validator'
import { useNavigate } from 'react-router-dom';
import { isMobile } from 'react-device-detect';
import SUBSTIUICAO from '../../../images/substituir.png'


export const CRTAprovadasPJ = (props) => {

    const navigate = useNavigate()
    const [loading, setLoading] = useState(false)
    const [loading2, setLoading2] = useState(false)
    const [msg, setMsg] = useState('')
    const { addToast } = useToasts()
    const [dataMinhasCRT, setDataMinhasCRT] = useState(undefined)
    const [dataSolicitacoes, setDataSolicitacoes] = useState(undefined)
    const [user, setUser] = useRecoilState(userState)
    const [open, setOpen] = useState(false)
    const [CNPJ, setCNPJ] = useState('10.260.249/0003-51')
    const [selected, setSelected] = useState(undefined)
    const [openSelected, setOpenSelected] = useState(false)
    const [solicitacao, setSolicitacao] = useState({
        formapagamento: 0,
        crq: user?.crq,
        vinculo: 0,
        nome: user?.nome,
        cpf: user?.cpf,
        horas: 2,
        atividade: "Responsável Técnico da Empresa.",
        anexo: false,
        firma: {

        }
    })



    useEffect(() => {
        console.log(user)
        if (user?.isprofissional === 0)
            getMinhasCRTs()
        else
            navigate('/login')
    }, [])


    async function getMinhasCRTs() {
        try {
            setLoading(true)
            const result = await api.get('/api/v1.0/registrado/minhas_crt',
                {
                    headers: {
                        'x-access-token': user?.token2
                    }
                }
            )
            console.log(result.data)
            setDataMinhasCRT(result.data)
        } catch (error) {
            addToast(error.message, { autoDismiss: true, appearance: 'error' })
        }
        setLoading(false)
    }



    async function crqSolicitacao(id) {
        try {
            setLoading2(true)
            const result = await api.get('/api/v1.0/registrado/crt/id',
                {
                    headers: {
                        'x-access-token': user?.token2
                    },
                    params: {
                        id: id
                    }
                }
            )
            setSelected(result.data)
            console.log(result.data)
        } catch (error) {
            addToast(error.message, { autoDismiss: true, appearance: 'error' })
        }
        setLoading2(false)
    }

    function renderStatus(item) {
        switch (item.status) {
            case 1: return <Tag color={'blue'}>Recebido</Tag>
            case 2: return <Tooltip title="Documentação conferida, processo encaminhado para Plenária."> <Tag color={'blue-inverse'}>Aguardando Plenária</Tag> </Tooltip>
        }

        return ""
    }


    function renderComunicacoes() {
        return <Flex vertical gap={5}>
            <Flex justify='flex-end'>

            </Flex>
            <Table id='tablesmall2' size='small' bordered pagination={false} dataSource={dataMinhasCRT} loading={loading}>
                <Table.Column hidden={isMobile} title={"Processo"} render={(txt, item, index) => {
                    return <Flex style={{ fontSize: '0.9em' }}>{item.processo}</Flex>
                }} />

                <Table.Column title={"Profissional"} render={(txt, item, index) => {
                    return <Flex style={{ fontSize: '0.9em' }}>{item.nome}</Flex>
                }} />
                <Table.Column hidden={isMobile} title={"CRQ"} align='center' width={130} render={(txt, item, index) => {
                    return <Flex style={{ fontSize: '0.9em' }} justify='center'>{item.crqxp}</Flex>
                }} />

                <Table.Column title={"Vigência"} align='center' render={(txt, item, index) => {
                    return <Flex style={{ fontSize: '0.9em' }} justify='center'>{item.vigencia}</Flex>
                }} />
                <Table.Column title={"Validade"} width={115} align='center' render={(txt, item, index) => {
                    if (!item.vigencia)
                        return <Flex></Flex>
                    let validade = "31/03/".concat(item.vigencia + 1)
                    return <Flex style={{ fontSize: '0.9em' }} justify='center'>

                        {validade}
                    </Flex>
                }} />

                <Table.Column title={""} align='center' render={(txt, item, index) => {

                    if (!item.vigencia)
                        return <Flex></Flex>

                    return <Flex justify='center' gap={5} align='center'>

                        

                        <Button type='link' size='small' icon={<DownloadOutlined />} style={{ fontSize: '0.95em' }}
                            onClick={async () => {
                                try {
                                    // console.log(item)
                                    //return
                                    const result = await api.get('/api/v1.0/registrado/ccrt/download',
                                        {
                                            headers: {
                                                'x-access-token': user?.token2
                                            },
                                            params: {
                                                id: item.crtvigenciaid
                                            },
                                            responseType: 'blob'
                                        }
                                    )
                                    //   console.log(result.data)


                                    const pdfBlob = new Blob([result.data], { type: "application/pdf" });
                                    // Cria uma URL temporária para o Blob 
                                    const url = window.URL.createObjectURL(pdfBlob);
                                    // Cria         um elemento <a> temporário para iniciar o download 
                                    const tempLink = document.createElement("a");
                                    tempLink.href = url;
                                    tempLink.setAttribute("download", "ccrt".concat('.pdf'));
                                    // Define o nome de arquivo desejado para o arquivo baixado 
                                    // Adiciona o elemento <a> ao corpo e clica nele para iniciar o download 
                                    document.body.appendChild(tempLink);
                                    tempLink.click();
                                    // Limpa os elementos temporários e a URL 
                                    document.body.removeChild(tempLink);
                                    window.URL.revokeObjectURL(url);


                                } catch (error) {
                                    addToast(error, {
                                        autoDismiss: true,
                                        appearance: 'error'
                                    })
                                }
                            }}>Download</Button>

                           {
                            /* 
                             <Button type='link' style={{ fontSize: '0.95em' }} icon={<Image preview={false} height={15}
                             width={15} alt={"subs"} src={SUBSTIUICAO} />}>Substituir</Button>
                            */
                           }
                    </Flex>
                }} />

            </Table>
        </Flex>
    }



    function validar() {
        let validado = true
        try {
            if (!(solicitacao.firma.fiid > 0))
                validado = false

            if ((solicitacao.atividade.trim() === ''))
                validado = false

            if (!(solicitacao.anexo === true))
                validado = false

            if (!(solicitacao.aceite === true))
                validado = false

        } catch (error) {

        }
        return !validado
    }



    return <Flex vertical gap={10}>

        <Breadcrumb items={[
            {
                title: <Flex align='center' gap={5}><FileTextOutlined /> Comunicações de Responsabilidade Técnica</Flex>,
            }, {
                title: "Ativas (".concat(dataMinhasCRT ? dataMinhasCRT?.length : '', ')')
            }
        ]} />

        {renderComunicacoes()}
        {/*   <Tabs defaultActiveKey="1" items={items} onChange={onChange} style={{ backgroundColor: 'white' }} /> */}


    </Flex>

}